import React, { Component } from 'react';
import Img from 'react-image'
import srcIconClose from '../../../../styles/img/close.svg';
import { Service } from '../../../service/service';
import { API } from '../../../../const';
import srcIconEquipeBleu from '../../../../styles/img/icon-equipe-blue.svg';
import srcIconCheckWhite from '../../../../styles/img/icon-check-white.svg';
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux'
import { styles } from "../../../../ReactConst"
import { StyleRoot } from 'radium';
import StaffCheckbox from './StaffCheckbox';
function jsUpperCaseFirst(string) {
    return _.isEmpty(string) ? string : string.charAt(0).toUpperCase();
}
function toUpperCaseFirst(string) {
    if (!_.isEmpty(string)) {
        string.toLowerCase();
        return (string.charAt(0).toUpperCase() + string.substring(1));
    }
}
const IconClose = () => <Img src={srcIconClose} className='img-fluid' />
const IconEquipeBleu = () => <Img src={srcIconEquipeBleu} className='img-fluid icon-modal-title' />
const IconCheckWhite = () => <Img src={srcIconCheckWhite} className='img-fluid' />
class ModaleEquipe extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listAgent: [],
            touched: false,
            period: "",
            styleFadeIn: true

        }
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleCheck = this.handleCheck.bind(this)
    }
    componentDidMount() {
        let period = this.props.currentPeriod === "matin" ? "Matin" : this.props.currentPeriod === "midi" ? "Midi" : "Aprés Midi"

        if (!_.isEmpty(this.props.allAgents)) {
            let arrayOfAgents = [];
            let currentPeriodAgents = []; currentPeriodAgents = !_.isEmpty(this.props.currentPeriodAgents) ? this.props.currentPeriodAgents : [];

            if (!_.isEmpty(this.props.allAgents)) {
                this.props.allAgents.map((element, index) => {

                    let condition = currentPeriodAgents.find(currAgent => element.agent.id === currAgent.id)
                    if (condition) {
                        arrayOfAgents.push({ ...element.agent, present: true })
                    } else {
                        arrayOfAgents.push({ ...element.agent, present: false })
                    }
                })
            }
            this.setState({
                listAgent: arrayOfAgents,
                period
            })
        }
        this.setState({
            period
        })
    }

    handleCheck(element, index) {
        let agentCheck = Object.assign({}, element, { present: !element.present })
        let period = this.props.currentPeriod === "matin" ? "MATIN" : this.props.currentPeriod === "midi" ? "MIDI" : "APRES_MIDI"
        let data = {
            "creneau": period,
            "date": this.props.currentDay,
            "idAgent": element.id,
            "present": !element.present
        }
        this.setState({ touched: true })
        const response = Service.post(`${API}api/creche/staffings`, data, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })
        response.then((res) => {
            let array = this.state.listAgent;
            array[index] = agentCheck
            this.setState({ listAgent: array })
        })
        response.catch(err => {
        }
        )
    }
    handleSubmit(e) {
        e.preventDefault();
        if (this.state.touched) {
            let arrayOfAgents = this.state.listAgent.filter(element => {
                let present = element.present;
                delete element.present
                if (present) return element
            })
            this.setState({
                styleFadeIn: false
            })
            setTimeout(() => {
                this.props.submitModaleEquipe(arrayOfAgents)
            }, 500);

        } else {
            this.setState({
                styleFadeIn: false
            })
            setTimeout(() => {
                this.props.closeModaleEquipe()
            }, 500);
        }
    }

    componentWillMount() {
        this.setState({ styleFadeIn: true })
    }

    closeModalEquipe = () => {
        this.setState({
            styleFadeIn: false
        })
        setTimeout(() => {
            this.props.closeModaleEquipe()
        }, 500);
    }

    render() {
        return (
            <StyleRoot>
                <div className="modal fade modal-skin show actif" id="modalEquipe" tabIndex="-1" role="dialog" aria-labelledby="modalEquipe" aria-hidden="true"
                    style={this.state.styleFadeIn === true ? styles.bounce : styles.bounce2}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <form onSubmit={this.handleSubmit}>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeModalEquipe}>
                                    <IconClose />
                                </button>
                                <div className="modal-body" style={{ fontSize: "1rem", fontWeight: "400", lineHeight: "1.5" }}>
                                    <section>
                                        <h5 className="modal-title mt-0"><IconEquipeBleu /> {moment(this.props.currentDay).format("D MMMM")} - {this.state.period}</h5>
                                        <ul className="row mx-n2 list-enfants">
                                            {!_.isEmpty(this.state.listAgent) && this.state.listAgent.map((element, index) => {
                                                return (
                                                    <StaffCheckbox
                                                        staff={element}
                                                        handleCheck={this.handleCheck}
                                                        index={index}
                                                        key={index}
                                                    />
                                            )
                                            })}
                                        </ul>
                                    </section>
                                    <div className="d-flex justify-content-center">
                                        <button type="submit" className="btn-gradient btn-valid"><IconCheckWhite /> Valider</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </StyleRoot>
        )
    }
}

const mapStateToProps = (state) => ({})
const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(ModaleEquipe)



